import { render } from "./BaseLoadingSpinner.vue?vue&type=template&id=2a627ed2&scoped=true"
import script from "./BaseLoadingSpinner.vue?vue&type=script&lang=js"
export * from "./BaseLoadingSpinner.vue?vue&type=script&lang=js"

import "./BaseLoadingSpinner.vue?vue&type=style&index=0&id=2a627ed2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-web-app/user-web-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a627ed2"]])

export default __exports__